import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Button} from 'antd'
import DeleteModal from './Modals/Delete'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  state = {
    modal: false
  }
  openModal = () => {
    this.setState({modal: true})
  }
  closeModal = () => {
    this.setState({modal: false})
  }
  check = (e) => {
    const {permissions} = this.props.store
    if (permissions.checkUpgrade('lab.algo.create')) {
      e.preventDefault()
      permissions.wrap('lab.algo.create')
    }
  }
  render() {
    const {algo, backtest, permissions} = this.props.store
    const deletePermission = permissions.check('lab.algo.delete')
    const deleteDisabled = (!algo.list.selected.length && !backtest.list.selected.length) || !deletePermission

    return(
      <div styleName='wrapper'>
        <DeleteModal
          visible={this.state.modal}
          close={this.closeModal}
          tab={this.props.tab}
        />
        <Link to='/builder' onClick={this.check}>
          <Button
            type='primary'
            icon='plus'
            className={`${permissions.checkUpgrade('lab.algo.create') ? 'upgrade-ribbon' : ''}`}
            styleName='create'
          >
            New Algorithm
          </Button>
        </Link>
        <Button
          type='danger'
          icon='delete'
          loading={algo.deleting}
          onClick={this.openModal}
          disabled={deleteDisabled}
        />
      </div>
    )
  }
}

export default Controls
